module.exports = __webpack_public_path__ + "img/p2-64.20867caf.png";